var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('wrap-container',[_c('h1',{staticClass:"titulo titulo--principal p32 oscuro medium"},[_vm._v(" Libro de Quejas Online ")]),_c('formulario-contacto')],1)}
var staticRenderFns = []

export { render, staticRenderFns }